import { darkGrayFontColor } from '../../styles/colors';
import { CssSelectors } from '../../styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	root: {
		':disabled': {
			cursor: 'default',
		},
		':focus': {
			boxShadow: 'rgba(169,169, 169,.4) 0px 1px 2px 1px',
		},
		':hover': {
			boxShadow: 'rgba(169,169, 169,.4) 0px 1px 2px 1px',
		},
		alignItems: 'center',
		borderRadius: '1.25rem',
		color: darkGrayFontColor,
		display: 'flex',
		fontSize: '0.875rem',
		justifyContent: 'center',
		letterSpacing: 0,
		padding: '0.5rem 0.75rem',
		transform: 'translate3d(0px, 0px, 0px)',
		transition: 'opacity 0.2s ease 0s, transform 0.2s ease 0s',
		...CssSelectors.allChildren(
			{
				marginLeft: '0.5rem',
			},
			':not(:first-child)'
		),
	},
});
